import { render, staticRenderFns } from "./ContactListRecommend.vue?vue&type=template&id=3234972d&scoped=true"
import script from "./ContactListRecommend.vue?vue&type=script&lang=js"
export * from "./ContactListRecommend.vue?vue&type=script&lang=js"
import style0 from "./ContactListRecommend.vue?vue&type=style&index=0&id=3234972d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3234972d",
  null
  
)

export default component.exports